import { AppEntitySchema as CoreAppEntitySchema } from '@pkg/db/schema'
import { z } from 'zod'

export const AppEntity = CoreAppEntitySchema.extend({
  deletedBy: z.string().nullish(),
  deletedAt: z.union([z.date(), z.iso.datetime({ offset: true })]).nullish(),
})

export type AppEntityType = z.infer<typeof AppEntity>
